import { useFormik } from "formik";
import * as yup from "yup";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  addVideoCategory,
  getCategoryById,
  updateCategory,
} from "../../axios/api"; // Adjust the import path as necessary
import Loader from "components/loader"; // Adjust the import path as necessary
import { useEffect, useState } from "react";
import { toast } from "react-toastify";

const AddVideoCategory = () => {
  const params = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const id = location?.state;

  const [category, setCategory] = useState<any>();
  const [loading, setLoading] = useState(false);

  const formik = useFormik({
    initialValues: {
      title: "",
    },
    onSubmit: async (values) => {
      try {
        setLoading(true);
        let responseData;
        const reqBody = {
          title: encodeURI(values.title),
          locale: "1",
          video_category_id: values.title,
        };
        if (id) {
          responseData = await updateCategory(reqBody, id);
          if (responseData?.data?.success) {
            toast.success("Category Updated Successfully");
            navigate("/admin/video-category");
          } else {
            if (responseData?.data.message == "Category Already Exist") {
              toast.error(responseData?.data.message);
            } else {
              toast.error("Something Went Wrong" + responseData);
            }
          }
        } else {
          responseData = await addVideoCategory(reqBody);
          if (responseData?.success) {
            toast.success("Category Added Successfully");
            navigate("/admin/video-category");
          } else {
            if (responseData?.message == "Category Already Exist") {
              toast.error(responseData?.message);
            } else {
              toast.error("Something Went Wrong" + responseData);
            }
          }
        }
        // console.log("API Response:", responseData);
      } catch (error) {
        console.error("API Error:", error);
        toast.error("Something Went Wrong" + error);
      } finally {
        setLoading(false);
      }
    },
    validationSchema: yup.object({
      title: yup.string().required("Title is required"),
    }),
  });
  useEffect(() => {
    const fetchCategory = async (id: string) => {
      try {
        setLoading(true);
        const categoryDataResp = await getCategoryById(id);
        setCategory(categoryDataResp?.data?.data);
      } catch (error) {
        console.log("error", error);
      } finally {
        setLoading(false);
      }
    };
    if (id) {
      fetchCategory(id);
    }
  }, [id]);

  useEffect(() => {
    if (category) {
      formik.setValues({
        title: category.title,
      });
    }
  }, [category]);

  return (
    <div className="m-3 bg-[#FFFFFF] p-3">
      {loading ? (
        <Loader />
      ) : (
        <form onSubmit={formik.handleSubmit}>
          <div className="my-5 flex w-11/12 flex-col">
            <div className="my-2 flex w-[61%] flex-col items-start justify-center gap-2">
              <label htmlFor="title" className="text-xl font-medium">
                Video Category Title
              </label>
              <input
                type="text"
                name="title"
                id="title"
                value={formik.values.title}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                placeholder="Enter Video Category Title here"
                className="h-10 w-[100%] rounded-md border-[2px] border-[#E4E6EF] bg-[transparent] p-2"
              />
              {formik.touched.title && formik.errors.title ? (
                <div className="text-lg text-red-500">
                  {formik.errors.title}
                </div>
              ) : null}
              <div>
                <button
                  name="submit"
                  className="float-right my-5 w-24 rounded bg-[#008BD2] p-2 text-xl font-bold text-white"
                  type="submit"
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
        </form>
      )}
    </div>
  );
};

export default AddVideoCategory;
